import { allWorks, categories } from "@/mocks/naruto";
import type { WorkItem } from "@/mocks/naruto";

interface Props {
  activeCategory: string;
  onSelect: (name: string) => void;
}

function WorkCard({ work }: { work: WorkItem }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg bg-background-100 transition-all hover:-translate-y-1">
      <div className="relative h-56 w-full overflow-hidden">
        <img
          src={work.cover}
          alt={`${work.title} - ${work.category}同人本子封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs text-background-50">
          <i className="ri-star-smile-line"></i>
          {work.rating}
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-background-950/60 px-2.5 py-0.5 text-xs text-background-50">
          {work.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="text-base font-semibold text-foreground-950">{work.title}</h3>
        <p className="mt-0.5 text-xs text-foreground-500">作者 · {work.author}</p>
        <p className="mt-2.5 line-clamp-3 text-sm leading-relaxed text-foreground-700">{work.summary}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.tags.map((tag) => (
            <span key={tag} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}

export default function WorksSection({ activeCategory, onSelect }: Props) {
  const tabs = ["全部", ...categories.map((c) => c.name)];
  const list =
    activeCategory === "全部" ? allWorks : allWorks.filter((w) => w.category === activeCategory);

  return (
    <section id="hot" className="w-full bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="text-sm font-medium text-primary-600">编辑精选 · 剧情向推荐</p>
            <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">热门同人本子推荐</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              按CP筛选火影同人本子，下面是收录的热门作品，点选分类即可快速定位想看的故事。
            </p>
          </div>
        </div>

        <div className="mb-7 flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => onSelect(tab)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                activeCategory === tab
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:bg-secondary-100"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {list.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}